import Button from "components/Button";
import Popover from "components/Popover";

import { ReactComponent as EditIcon } from "assets/images/common/edit.svg";
import { ReactComponent as EyeOpenIcon } from "assets/images/common/eye-open.svg";
import { ReactComponent as TrashIcon } from "assets/images/common/trash.svg";

type TableRowActionsProps = {
  id: number;
  flags?: {
    view?: boolean;
    edit?: boolean;
    remove?: boolean;
  };
  isDisabledRemove?: boolean;
  isDisabledEdit?: boolean;
  isDisabledView?: boolean;
  disabledRemoveMessage?: string;
  disabledEditMessage?: string;
  disabledViewMessage?: string;
  onView?: (id: number) => void;
  onEdit?: (id: number) => void;
  onRemove?: (id: number) => void;
};

const TableRowActions = ({
  id,
  flags = { view: true, edit: true, remove: true },
  isDisabledRemove = false,
  isDisabledEdit = false,
  isDisabledView = false,
  disabledRemoveMessage,
  disabledEditMessage,
  disabledViewMessage,
  onView,
  onEdit,
  onRemove,
}: TableRowActionsProps) => (
  <div className={"table-actions"}>
    {flags.edit !== false && (
      <Popover
        id={`edit-popover-${id}`}
        content={disabledEditMessage}
        positionY="middle"
        positionX="left"
        variant="hover"
        popoverClassName={"table-actions__popover__edit"}
      >
        <Button
          variant="link"
          aria-label="Edit"
          className={"table-actions__button table-actions__button__edit"}
          onClick={() => onEdit?.(id)}
          disabled={isDisabledEdit}
        >
          <EditIcon />
        </Button>
      </Popover>
    )}
    {flags.view !== false && (
      <Popover
        id={`view-popover-${id}`}
        content={disabledViewMessage}
        positionY="middle"
        positionX="left"
        variant="hover"
        popoverClassName={"table-actions__popover__view"}
      >
        <Button
          variant="link"
          aria-label="View"
          className={"table-actions__button table-actions__button__view"}
          onClick={() => onView?.(id)}
          disabled={isDisabledView}
        >
          <EyeOpenIcon />
        </Button>
      </Popover>
    )}
    {flags.remove !== false && (
      <Popover
        id={`remove-popover-${id}`}
        content={disabledRemoveMessage}
        positionY="middle"
        positionX="left"
        variant="hover"
        popoverClassName={"table-actions__popover__remove"}
      >
        <Button
          variant="link"
          aria-label="Remove company"
          className={"table-actions__button table-actions__button__remove"}
          onClick={() => onRemove?.(id)}
          disabled={isDisabledRemove}
        >
          <TrashIcon />
        </Button>
      </Popover>
    )}
  </div>
);

export default TableRowActions;
